import { createFileRoute } from "@tanstack/react-router";

import { useMe } from "../features/auth/session";
import { InsightsPage } from "../features/autopilot/InsightsPage";
import { useT } from "../i18n/I18nProvider";

export const Route = createFileRoute("/app/insights")({
  component: InsightsRoute,
});

function InsightsRoute() {
  const t = useT();
  const me = useMe();
  if (!me.data) return <p>{t("common.loading")}</p>;
  return <InsightsPage key={me.data.activeOrganizationId ?? "none"} me={me.data} />;
}
